import React from "react";
import Avatar from "@atlaskit/avatar";
import { formatDateJobLog } from "../../../helpers/helpers";
import styles from "./Wrapper.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);

export const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);

export const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);

export const createHead = (withWidth) => {
  return {
    cells: [
      {
        key: "id",
        content: "Id",
        isSortable: false,
        width: withWidth ? 10 : undefined,
      },
      {
        key: "event",
        content: "Event",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
      {
        key: "action",
        content: "Event Detail",
        isSortable: false,
        width: withWidth ? 80 : undefined,
      },
      {
        key: "timestamp",
        content: "Timestamp (UTC)",
        isSortable: false,
        width: withWidth ? 35 : undefined,
      },
      {
        key: "userName",
        content: "Name",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
    ],
  };
};

function createKey(input) {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
}

export const createCells = (tableData) =>
  tableData.map((data, index) => ({
    key: `row-${index}-${data.id}`,
    cells: [
      {
        key: createKey(data.id.toString()),
        content: data.id,
      },

      {
        key: createKey(data.eventType),
        content: data.eventType,
      },
      {
        key: createKey(data.eventDetail),
        content: data.eventDetail ? data.eventDetail : "-",
      },
      {
        key: createKey(data.timestamp),
        content: formatDateJobLog(data.timestamp, false),
        //content: moment(data.date).format("llll"),
      },
      {
        key: createKey("Username"),
        content:
          data.userName === "Not found" ? (
            data.accountId
          ) : (
            <NameWrapper>
              <AvatarWrapper>
                <Avatar src={data.avatar} name={"USername"} size="small" />
              </AvatarWrapper>
              {data.userName === "-" ? (
                <Skeleton
                  width={"150px"}
                  count={1}
                  baseColor="lightgrey"
                  height={"10px"}
                />
              ) : (
                data.userName
              )}
            </NameWrapper>
          ),
      },
    ],
  }));
